export class SchoolYearModel {

  _id: string;
  name: string;
  country: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
  isClosed: boolean;
  createdAt: string;
  updatedAt: string;

  static generate(data: any): SchoolYearModel {
    const m = new SchoolYearModel();
    if (!data) {
      return m;
    }
    m._id       = data._id;
    m.name      = data.name;
    m.country   = data.country;
    m.startDate = data.startDate;
    m.endDate   = data.endDate;
    m.isActive  = data.isActive;
    m.isClosed  = data.isClosed;
    m.createdAt = data.createdAt;
    m.updatedAt = data.updatedAt;
    return m;
  }

  static generateList(data: any[]): SchoolYearModel[] {
    if (!data) {
      return [];
    }
    return data.map(d => SchoolYearModel.generate(d));
  }

  get statusLabel(): string {
    if (this.isClosed) {
      return 'Closed';
    }
    if (this.isActive) {
      return 'Active';
    }
    return 'Pending';
  }
}

export class SchoolYearFilter {
  country: string;
  isActive: boolean;
  isClosed: boolean;
}

export class CreateSchoolYearPayload {
  name: string;
  country: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
}

export class UpdateSchoolYearPayload {
  name: string;
  startDate: string;
  endDate: string;
  isActive: boolean;
}
